import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const items = [{
  title: "Diagnóstico inicial",
  desc: "Para conocer tu situación actual y definir en qué debemos enfocarnos."
}, {
  title: "Sesión estratégica 1 a 1",
  desc: "Una sesión personalizada de aproximadamente 60 minutos."
}, {
  title: "30 días de proceso",
  desc: "Ejercicios y acciones progresivas para trabajar paso a paso."
}, {
  title: "Seguimiento",
  desc: "Acompañamiento durante el proceso para ayudarte a mantener el enfoque."
}, {
  title: "Diagnóstico final",
  desc: "Revisamos tu evolución y los cambios que hayas experimentado durante el proceso."
}, {
  title: "Plan de próximos 30 días",
  desc: "Terminas con una dirección concreta para continuar trabajando en ti."
}];
export function Deliverables() {
  return <section className="py-24 md:py-32 bg-ink relative" data-id="element-100" data-mp="3uqd919ih0n0l">
      <div className="container mx-auto px-6" data-id="element-101" data-mp="3ury20up4zxwc">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-102" data-mp="3k5dp7lpr0psq">
          <h2 className="text-3xl md:text-5xl font-serif text-ivory-bright mb-6 uppercase" data-id="element-103" data-mp="3u1ytu5xuvyw1">
            TODO LO QUE RECIBES DURANTE LOS 30 DÍAS
          </h2>
          <p className="text-muted font-light text-lg" data-id="element-104" data-mp="7ogroh1mvc8v">
            Esto no es solamente una sesión de una hora. Es un proceso guiado de 30 días con una sesión estratégica personalizada y herramientas para continuar trabajando después.
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto bg-ink-light border border-white/5 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-105" data-mp="lngfjmhbnn3z">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-106" data-mp="2ig07qlbtu80x">
            {items.map((item, index) => <motion.div key={index} className="flex items-start gap-4" initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} data-id="element-107" data-mp="2ne1mwv64tn74" data-mpi={index}>
                <div className="mt-1 bg-gold/10 p-1.5 rounded-full text-gold shrink-0" data-id="element-108" data-mp="2pdwbe9bnx23h">
                  <Check className="w-4 h-4" data-id="element-109" data-mp="2kcgpkf1nurk1" />
                </div>
                <div data-id="element-110" data-mp="2ychovq2a1qxe">
                  <h4 className="text-ivory-bright font-medium mb-1" data-id="element-111" data-mp="2yby7cagjh4jw">{item.title}</h4>
                  <p className="text-muted font-light text-sm leading-relaxed" data-id="element-112" data-mp="2uc7l8k1yjclp">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}